/**
 * Created by akirilyuk on 11/16/16.
 */
define(function (require) {
    "use strict";

    var KPSnippetView = require("connection-views/KPsTab/KPSnippetView");
    var Template = require("connection-templates/ticketTab/ArticleSuggestionRowView.tmpl");
    var NoResultsView = require("connection-views/KPsTab/NoResultsView");
    var KPsSearchResultsCollection = require("connection-collections/KPsTab/KPsSearchResultsCollection");
    var CP_CONST = require("connection-const");

    var ArticleSuggestionRowView = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        ArticleSuggestionRowView = Marionette.CompositeView.extend({
            itemView: KPSnippetView,
            itemViewContainer: ".suggestion-row",
            template: Template,
            emptyView: NoResultsView,
            className: "article-suggestion-row-view",

            initialize: function (options) {
                this.collection = new Backbone.Collection(_.toArray(this.model.attributes));
                this.itemViewOptions = {
                    type: options.type || CP_CONST.REFERER_ACTION.SEARCH_RESULTS_SNIPPET
                };
            },

            onRender: function(){
                if(this.collection.length%2===0){
                    this.children.each(function(current){
                        current.$el.addClass("double");
                    });
                }
            }
        });
    });

    return ArticleSuggestionRowView;


});
